jQuery(".m-header__search button").bind("click",function(){

    var searchForm = jQuery(this).closest(".m-header__search");
    jQuery(searchForm).toggleClass("js-m-header__search--isactive");

    if(jQuery(searchForm).hasClass("js-m-header__search--isactive")) {
        jQuery(".m-header__search input").focus();
    }

});